import { render, staticRenderFns } from "./NoticeInfo.vue?vue&type=template&id=0c3426aa&scoped=true&"
import script from "./NoticeInfo.vue?vue&type=script&lang=js&"
export * from "./NoticeInfo.vue?vue&type=script&lang=js&"
import style0 from "./NoticeInfo.vue?vue&type=style&index=0&id=0c3426aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3426aa",
  null
  
)

export default component.exports